import React from "react";
import { useTranslation } from "react-i18next";
import { useQueryClient } from "@tanstack/react-query";

import { NoteForm, NoteList } from "./";
import { ManagementLayout } from "@components/shared";
import { Card, Title } from "@mantine/core";

export default function NoteManagement({ reqData = {} }) {
  const { t } = useTranslation();
  const queryClient = useQueryClient();

  function onNoteCreate() {
    queryClient.invalidateQueries({
      queryKey: ["notes", JSON.stringify(reqData)],
    });
  }

  return (
    <ManagementLayout
      dataComponent={<NoteList reqData={reqData} />}
      createComponent={
        <Card>
          <Title order={4}>
            {t("create")} {t("note_singular")}
          </Title>
          <NoteForm reqData={reqData} onSuccess={onNoteCreate} />
        </Card>
      }
    />
  );
}
